module.exports = __webpack_public_path__ + "static/media/Security check.17af89ae.svg";